import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var PostType = /*#__PURE__*/function (PostType) {
  PostType[PostType["POST_TYPE_INVALID"] = 0] = "POST_TYPE_INVALID";
  PostType[PostType["POST_TYPE_IMAGE"] = 1] = "POST_TYPE_IMAGE";
  PostType[PostType["POST_TYPE_VIDEO"] = 2] = "POST_TYPE_VIDEO";
  PostType[PostType["POST_TYPE_GIF"] = 3] = "POST_TYPE_GIF";
  PostType[PostType["POST_TYPE_REEL"] = 4] = "POST_TYPE_REEL";
  PostType[PostType["POST_TYPE_CAROUSEL"] = 5] = "POST_TYPE_CAROUSEL";
  return PostType;
}(PostType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var GetBusinessStatsResponseStatus = /*#__PURE__*/function (GetBusinessStatsResponseStatus) {
  GetBusinessStatsResponseStatus[GetBusinessStatsResponseStatus["GET_BUSINESS_STATS_RESPONSE_STATUS_IN_PROGRESS"] = 0] = "GET_BUSINESS_STATS_RESPONSE_STATUS_IN_PROGRESS";
  GetBusinessStatsResponseStatus[GetBusinessStatsResponseStatus["GET_BUSINESS_STATS_RESPONSE_STATUS_FINISHED"] = 1] = "GET_BUSINESS_STATS_RESPONSE_STATUS_FINISHED";
  return GetBusinessStatsResponseStatus;
}(GetBusinessStatsResponseStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BusinessStats {
  static fromProto(proto) {
    let m = new BusinessStats();
    m = Object.assign(m, proto);
    if (proto.timestamp) {
      m.timestamp = new Date(proto.timestamp);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.followersCount) {
      m.followersCount = parseInt(proto.followersCount, 10);
    }
    if (proto.mediaCount) {
      m.mediaCount = parseInt(proto.mediaCount, 10);
    }
    if (proto.stats) {
      m.stats = BusinessStatsStats.fromProto(proto.stats);
    }
    if (proto.error) {
      m.error = BusinessStatsError.fromProto(proto.error);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.username !== 'undefined') {
      toReturn['username'] = this.username;
    }
    if (typeof this.timestamp !== 'undefined' && this.timestamp !== null) {
      toReturn['timestamp'] = 'toApiJson' in this.timestamp ? this.timestamp.toApiJson() : this.timestamp;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.followersCount !== 'undefined') {
      toReturn['followersCount'] = this.followersCount;
    }
    if (typeof this.mediaCount !== 'undefined') {
      toReturn['mediaCount'] = this.mediaCount;
    }
    if (typeof this.stats !== 'undefined' && this.stats !== null) {
      toReturn['stats'] = 'toApiJson' in this.stats ? this.stats.toApiJson() : this.stats;
    }
    if (typeof this.error !== 'undefined' && this.error !== null) {
      toReturn['error'] = 'toApiJson' in this.error ? this.error.toApiJson() : this.error;
    }
    return toReturn;
  }
}
class BusinessStatsError {
  static fromProto(proto) {
    let m = new BusinessStatsError();
    m = Object.assign(m, proto);
    if (proto.code) {
      m.code = parseInt(proto.code, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.code !== 'undefined') {
      toReturn['code'] = this.code;
    }
    return toReturn;
  }
}
class BusinessStatsStats {
  static fromProto(proto) {
    let m = new BusinessStatsStats();
    m = Object.assign(m, proto);
    if (proto.followersCount) {
      m.followersCount = parseInt(proto.followersCount, 10);
    }
    if (proto.mediaCount) {
      m.mediaCount = parseInt(proto.mediaCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.followersCount !== 'undefined') {
      toReturn['followersCount'] = this.followersCount;
    }
    if (typeof this.mediaCount !== 'undefined') {
      toReturn['mediaCount'] = this.mediaCount;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Comment {
  static fromProto(proto) {
    let m = new Comment();
    m = Object.assign(m, proto);
    if (proto.postedOn) {
      m.postedOn = new Date(proto.postedOn);
    }
    if (proto.likeCount) {
      m.likeCount = parseInt(proto.likeCount, 10);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.commentId !== 'undefined') {
      toReturn['commentId'] = this.commentId;
    }
    if (typeof this.parentId !== 'undefined') {
      toReturn['parentId'] = this.parentId;
    }
    if (typeof this.mediaId !== 'undefined') {
      toReturn['mediaId'] = this.mediaId;
    }
    if (typeof this.instagramCommentId !== 'undefined') {
      toReturn['instagramCommentId'] = this.instagramCommentId;
    }
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.username !== 'undefined') {
      toReturn['username'] = this.username;
    }
    if (typeof this.instagramUserId !== 'undefined') {
      toReturn['instagramUserId'] = this.instagramUserId;
    }
    if (typeof this.postedOn !== 'undefined' && this.postedOn !== null) {
      toReturn['postedOn'] = 'toApiJson' in this.postedOn ? this.postedOn.toApiJson() : this.postedOn;
    }
    if (typeof this.likeCount !== 'undefined') {
      toReturn['likeCount'] = this.likeCount;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.hasReplies !== 'undefined') {
      toReturn['hasReplies'] = this.hasReplies;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class InstagramBusiness {
  static fromProto(proto) {
    let m = new InstagramBusiness();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.facebookPageId !== 'undefined') {
      toReturn['facebookPageId'] = this.facebookPageId;
    }
    if (typeof this.instagramBusinessId !== 'undefined') {
      toReturn['instagramBusinessId'] = this.instagramBusinessId;
    }
    if (typeof this.biography !== 'undefined') {
      toReturn['biography'] = this.biography;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.profilePictureUrl !== 'undefined') {
      toReturn['profilePictureUrl'] = this.profilePictureUrl;
    }
    if (typeof this.username !== 'undefined') {
      toReturn['username'] = this.username;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.canPost !== 'undefined') {
      toReturn['canPost'] = this.canPost;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Media {
  static fromProto(proto) {
    let m = new Media();
    m = Object.assign(m, proto);
    if (proto.postDateTime) {
      m.postDateTime = new Date(proto.postDateTime);
    }
    if (proto.postedDateTime) {
      m.postedDateTime = new Date(proto.postedDateTime);
    }
    if (proto.commentsCount) {
      m.commentsCount = parseInt(proto.commentsCount, 10);
    }
    if (proto.likeCount) {
      m.likeCount = parseInt(proto.likeCount, 10);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.reach) {
      m.reach = parseInt(proto.reach, 10);
    }
    if (proto.saves) {
      m.saves = parseInt(proto.saves, 10);
    }
    if (proto.videoViews) {
      m.videoViews = parseInt(proto.videoViews, 10);
    }
    if (proto.insightsUpdated) {
      m.insightsUpdated = new Date(proto.insightsUpdated);
    }
    if (proto.postType) {
      m.postType = enumStringToValue$5(PostType, proto.postType);
    }
    if (proto.deletedAt) {
      m.deletedAt = new Date(proto.deletedAt);
    }
    if (proto.mediaEntries) {
      m.mediaEntries = proto.mediaEntries.map(MediaEntry.fromProto);
    }
    if (proto.metaData) {
      m.metaData = proto.metaData.map(MetaData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.instagramUserId !== 'undefined') {
      toReturn['instagramUserId'] = this.instagramUserId;
    }
    if (typeof this.mediaId !== 'undefined') {
      toReturn['mediaId'] = this.mediaId;
    }
    if (typeof this.instagramMediaId !== 'undefined') {
      toReturn['instagramMediaId'] = this.instagramMediaId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.username !== 'undefined') {
      toReturn['username'] = this.username;
    }
    if (typeof this.postText !== 'undefined') {
      toReturn['postText'] = this.postText;
    }
    if (typeof this.postDateTime !== 'undefined' && this.postDateTime !== null) {
      toReturn['postDateTime'] = 'toApiJson' in this.postDateTime ? this.postDateTime.toApiJson() : this.postDateTime;
    }
    if (typeof this.imageUrl !== 'undefined') {
      toReturn['imageUrl'] = this.imageUrl;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.clientTags !== 'undefined') {
      toReturn['clientTags'] = this.clientTags;
    }
    if (typeof this.permalink !== 'undefined') {
      toReturn['permalink'] = this.permalink;
    }
    if (typeof this.error !== 'undefined') {
      toReturn['error'] = this.error;
    }
    if (typeof this.postedDateTime !== 'undefined' && this.postedDateTime !== null) {
      toReturn['postedDateTime'] = 'toApiJson' in this.postedDateTime ? this.postedDateTime.toApiJson() : this.postedDateTime;
    }
    if (typeof this.profilePictureUrl !== 'undefined') {
      toReturn['profilePictureUrl'] = this.profilePictureUrl;
    }
    if (typeof this.hasScheduledTask !== 'undefined') {
      toReturn['hasScheduledTask'] = this.hasScheduledTask;
    }
    if (typeof this.instagramCreationId !== 'undefined') {
      toReturn['instagramCreationId'] = this.instagramCreationId;
    }
    if (typeof this.commentsCount !== 'undefined') {
      toReturn['commentsCount'] = this.commentsCount;
    }
    if (typeof this.likeCount !== 'undefined') {
      toReturn['likeCount'] = this.likeCount;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.videoUrl !== 'undefined') {
      toReturn['videoUrl'] = this.videoUrl;
    }
    if (typeof this.postedByOwner !== 'undefined') {
      toReturn['postedByOwner'] = this.postedByOwner;
    }
    if (typeof this.linkShortcodes !== 'undefined') {
      toReturn['linkShortcodes'] = this.linkShortcodes;
    }
    if (typeof this.reach !== 'undefined') {
      toReturn['reach'] = this.reach;
    }
    if (typeof this.saves !== 'undefined') {
      toReturn['saves'] = this.saves;
    }
    if (typeof this.videoViews !== 'undefined') {
      toReturn['videoViews'] = this.videoViews;
    }
    if (typeof this.insightsUpdated !== 'undefined' && this.insightsUpdated !== null) {
      toReturn['insightsUpdated'] = 'toApiJson' in this.insightsUpdated ? this.insightsUpdated.toApiJson() : this.insightsUpdated;
    }
    if (typeof this.postType !== 'undefined') {
      toReturn['postType'] = this.postType;
    }
    if (typeof this.deletedAt !== 'undefined' && this.deletedAt !== null) {
      toReturn['deletedAt'] = 'toApiJson' in this.deletedAt ? this.deletedAt.toApiJson() : this.deletedAt;
    }
    if (typeof this.mediaEntries !== 'undefined' && this.mediaEntries !== null) {
      toReturn['mediaEntries'] = 'toApiJson' in this.mediaEntries ? this.mediaEntries.toApiJson() : this.mediaEntries;
    }
    if (typeof this.metaData !== 'undefined' && this.metaData !== null) {
      toReturn['metaData'] = 'toApiJson' in this.metaData ? this.metaData.toApiJson() : this.metaData;
    }
    if (typeof this.multilocationPostId !== 'undefined') {
      toReturn['multilocationPostId'] = this.multilocationPostId;
    }
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    return toReturn;
  }
}
class MediaEntry {
  static fromProto(proto) {
    let m = new MediaEntry();
    m = Object.assign(m, proto);
    if (proto.metaData) {
      m.metaData = proto.metaData.map(MetaData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.mediaEntryId !== 'undefined') {
      toReturn['mediaEntryId'] = this.mediaEntryId;
    }
    if (typeof this.mediaUrl !== 'undefined') {
      toReturn['mediaUrl'] = this.mediaUrl;
    }
    if (typeof this.mediaType !== 'undefined') {
      toReturn['mediaType'] = this.mediaType;
    }
    if (typeof this.containerId !== 'undefined') {
      toReturn['containerId'] = this.containerId;
    }
    if (typeof this.metaData !== 'undefined' && this.metaData !== null) {
      toReturn['metaData'] = 'toApiJson' in this.metaData ? this.metaData.toApiJson() : this.metaData;
    }
    return toReturn;
  }
}
class MediaKeyset {
  static fromProto(proto) {
    let m = new MediaKeyset();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.mediaId !== 'undefined') {
      toReturn['mediaId'] = this.mediaId;
    }
    return toReturn;
  }
}
class MetaData {
  static fromProto(proto) {
    let m = new MetaData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.propertyName !== 'undefined') {
      toReturn['propertyName'] = this.propertyName;
    }
    if (typeof this.propertyValue !== 'undefined') {
      toReturn['propertyValue'] = this.propertyValue;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Page {
  static fromProto(proto) {
    let m = new Page();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageId !== 'undefined') {
      toReturn['pageId'] = this.pageId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.perms !== 'undefined') {
      toReturn['perms'] = this.perms;
    }
    if (typeof this.tasks !== 'undefined') {
      toReturn['tasks'] = this.tasks;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class User {
  static fromProto(proto) {
    let m = new User();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.instagramUserId !== 'undefined') {
      toReturn['instagramUserId'] = this.instagramUserId;
    }
    if (typeof this.username !== 'undefined') {
      toReturn['username'] = this.username;
    }
    if (typeof this.profilePicture !== 'undefined') {
      toReturn['profilePicture'] = this.profilePicture;
    }
    if (typeof this.fullName !== 'undefined') {
      toReturn['fullName'] = this.fullName;
    }
    if (typeof this.bio !== 'undefined') {
      toReturn['bio'] = this.bio;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.isBusiness !== 'undefined') {
      toReturn['isBusiness'] = this.isBusiness;
    }
    if (typeof this.accessToken !== 'undefined') {
      toReturn['accessToken'] = this.accessToken;
    }
    if (typeof this.facebookUserId !== 'undefined') {
      toReturn['facebookUserId'] = this.facebookUserId;
    }
    if (typeof this.tokenBroken !== 'undefined') {
      toReturn['tokenBroken'] = this.tokenBroken;
    }
    if (typeof this.metaAppId !== 'undefined') {
      toReturn['metaAppId'] = this.metaAppId;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BreakInstagramUserTokenRequest {
  static fromProto(proto) {
    let m = new BreakInstagramUserTokenRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class ConnectInstagramBusinessRequest {
  static fromProto(proto) {
    let m = new ConnectInstagramBusinessRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.facebookPageId !== 'undefined') {
      toReturn['facebookPageId'] = this.facebookPageId;
    }
    if (typeof this.instagramBusinessId !== 'undefined') {
      toReturn['instagramBusinessId'] = this.instagramBusinessId;
    }
    return toReturn;
  }
}
class CreateCommentRequest {
  static fromProto(proto) {
    let m = new CreateCommentRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.mediaId !== 'undefined') {
      toReturn['mediaId'] = this.mediaId;
    }
    if (typeof this.parentId !== 'undefined') {
      toReturn['parentId'] = this.parentId;
    }
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    return toReturn;
  }
}
class CreateCommentResponse {
  static fromProto(proto) {
    let m = new CreateCommentResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.commentId !== 'undefined') {
      toReturn['commentId'] = this.commentId;
    }
    return toReturn;
  }
}
class CreateMediaRequest {
  static fromProto(proto) {
    let m = new CreateMediaRequest();
    m = Object.assign(m, proto);
    if (proto.postDateTime) {
      m.postDateTime = new Date(proto.postDateTime);
    }
    if (proto.metaData) {
      m.metaData = proto.metaData.map(MetaData.fromProto);
    }
    if (proto.mediaEntries) {
      m.mediaEntries = proto.mediaEntries.map(MediaEntry.fromProto);
    }
    if (proto.postType) {
      m.postType = enumStringToValue$2(PostType, proto.postType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.mediaId !== 'undefined') {
      toReturn['mediaId'] = this.mediaId;
    }
    if (typeof this.postText !== 'undefined') {
      toReturn['postText'] = this.postText;
    }
    if (typeof this.imageUrl !== 'undefined') {
      toReturn['imageUrl'] = this.imageUrl;
    }
    if (typeof this.postDateTime !== 'undefined' && this.postDateTime !== null) {
      toReturn['postDateTime'] = 'toApiJson' in this.postDateTime ? this.postDateTime.toApiJson() : this.postDateTime;
    }
    if (typeof this.hasScheduledTask !== 'undefined') {
      toReturn['hasScheduledTask'] = this.hasScheduledTask;
    }
    if (typeof this.videoUrl !== 'undefined') {
      toReturn['videoUrl'] = this.videoUrl;
    }
    if (typeof this.postedByOwner !== 'undefined') {
      toReturn['postedByOwner'] = this.postedByOwner;
    }
    if (typeof this.linkShortcodes !== 'undefined') {
      toReturn['linkShortcodes'] = this.linkShortcodes;
    }
    if (typeof this.metaData !== 'undefined' && this.metaData !== null) {
      toReturn['metaData'] = 'toApiJson' in this.metaData ? this.metaData.toApiJson() : this.metaData;
    }
    if (typeof this.mediaEntries !== 'undefined' && this.mediaEntries !== null) {
      toReturn['mediaEntries'] = 'toApiJson' in this.mediaEntries ? this.mediaEntries.toApiJson() : this.mediaEntries;
    }
    if (typeof this.postType !== 'undefined') {
      toReturn['postType'] = this.postType;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.multilocationPostId !== 'undefined') {
      toReturn['multilocationPostId'] = this.multilocationPostId;
    }
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    return toReturn;
  }
}
class CreateMediaResponse {
  static fromProto(proto) {
    let m = new CreateMediaResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.mediaId !== 'undefined') {
      toReturn['mediaId'] = this.mediaId;
    }
    return toReturn;
  }
}
class CreateUserRequest {
  static fromProto(proto) {
    let m = new CreateUserRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.instagramUserId !== 'undefined') {
      toReturn['instagramUserId'] = this.instagramUserId;
    }
    if (typeof this.username !== 'undefined') {
      toReturn['username'] = this.username;
    }
    if (typeof this.profilePicture !== 'undefined') {
      toReturn['profilePicture'] = this.profilePicture;
    }
    if (typeof this.fullName !== 'undefined') {
      toReturn['fullName'] = this.fullName;
    }
    if (typeof this.bio !== 'undefined') {
      toReturn['bio'] = this.bio;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.accessToken !== 'undefined') {
      toReturn['accessToken'] = this.accessToken;
    }
    return toReturn;
  }
}
class DeleteMediaRequest {
  static fromProto(proto) {
    let m = new DeleteMediaRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.instagramMediaId !== 'undefined') {
      toReturn['instagramMediaId'] = this.instagramMediaId;
    }
    return toReturn;
  }
}
class DeleteUserRequest {
  static fromProto(proto) {
    let m = new DeleteUserRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class GetBusinessStatsRequest {
  static fromProto(proto) {
    let m = new GetBusinessStatsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.username !== 'undefined') {
      toReturn['username'] = this.username;
    }
    return toReturn;
  }
}
class GetBusinessStatsResponse {
  static fromProto(proto) {
    let m = new GetBusinessStatsResponse();
    m = Object.assign(m, proto);
    if (proto.businessStats) {
      m.businessStats = BusinessStats.fromProto(proto.businessStats);
    }
    if (proto.status) {
      m.status = enumStringToValue$2(GetBusinessStatsResponseStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessStats !== 'undefined' && this.businessStats !== null) {
      toReturn['businessStats'] = 'toApiJson' in this.businessStats ? this.businessStats.toApiJson() : this.businessStats;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class GetInstagramBusinessRequest {
  static fromProto(proto) {
    let m = new GetInstagramBusinessRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.facebookPageId !== 'undefined') {
      toReturn['facebookPageId'] = this.facebookPageId;
    }
    return toReturn;
  }
}
class GetInstagramBusinessResponse {
  static fromProto(proto) {
    let m = new GetInstagramBusinessResponse();
    m = Object.assign(m, proto);
    if (proto.instagramBusiness) {
      m.instagramBusiness = InstagramBusiness.fromProto(proto.instagramBusiness);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.instagramBusiness !== 'undefined' && this.instagramBusiness !== null) {
      toReturn['instagramBusiness'] = 'toApiJson' in this.instagramBusiness ? this.instagramBusiness.toApiJson() : this.instagramBusiness;
    }
    return toReturn;
  }
}
class GetMediaRequest {
  static fromProto(proto) {
    let m = new GetMediaRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.instagramMediaId !== 'undefined') {
      toReturn['instagramMediaId'] = this.instagramMediaId;
    }
    return toReturn;
  }
}
class GetMediaResponse {
  static fromProto(proto) {
    let m = new GetMediaResponse();
    m = Object.assign(m, proto);
    if (proto.media) {
      m.media = Media.fromProto(proto.media);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.media !== 'undefined' && this.media !== null) {
      toReturn['media'] = 'toApiJson' in this.media ? this.media.toApiJson() : this.media;
    }
    return toReturn;
  }
}
class GetMultiMediaRequest {
  static fromProto(proto) {
    let m = new GetMultiMediaRequest();
    m = Object.assign(m, proto);
    if (proto.keysets) {
      m.keysets = proto.keysets.map(MediaKeyset.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.mediaId !== 'undefined') {
      toReturn['mediaId'] = this.mediaId;
    }
    if (typeof this.keysets !== 'undefined' && this.keysets !== null) {
      toReturn['keysets'] = 'toApiJson' in this.keysets ? this.keysets.toApiJson() : this.keysets;
    }
    return toReturn;
  }
}
class GetMultiMediaResponse {
  static fromProto(proto) {
    let m = new GetMultiMediaResponse();
    m = Object.assign(m, proto);
    if (proto.media) {
      m.media = proto.media.map(Media.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.media !== 'undefined' && this.media !== null) {
      toReturn['media'] = 'toApiJson' in this.media ? this.media.toApiJson() : this.media;
    }
    return toReturn;
  }
}
class GetMultiMediaStatsRequest {
  static fromProto(proto) {
    let m = new GetMultiMediaStatsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.mediaIds !== 'undefined') {
      toReturn['mediaIds'] = this.mediaIds;
    }
    return toReturn;
  }
}
class GetMultiMediaStatsResponse {
  static fromProto(proto) {
    let m = new GetMultiMediaStatsResponse();
    m = Object.assign(m, proto);
    if (proto.mediaStats) {
      m.mediaStats = Object.keys(proto.mediaStats).reduce((obj, k) => {
        obj[k] = MediaStats.fromProto(proto.mediaStats[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.mediaStats !== 'undefined' && this.mediaStats !== null) {
      toReturn['mediaStats'] = 'toApiJson' in this.mediaStats ? this.mediaStats.toApiJson() : this.mediaStats;
    }
    return toReturn;
  }
}
class GetUserRequest {
  static fromProto(proto) {
    let m = new GetUserRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class GetUserResponse {
  static fromProto(proto) {
    let m = new GetUserResponse();
    m = Object.assign(m, proto);
    if (proto.user) {
      m.user = User.fromProto(proto.user);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.user !== 'undefined' && this.user !== null) {
      toReturn['user'] = 'toApiJson' in this.user ? this.user.toApiJson() : this.user;
    }
    return toReturn;
  }
}
class ListCommentsRequest {
  static fromProto(proto) {
    let m = new ListCommentsRequest();
    m = Object.assign(m, proto);
    if (proto.options) {
      m.options = PagedRequestOptions.fromProto(proto.options);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.parentId !== 'undefined') {
      toReturn['parentId'] = this.parentId;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    return toReturn;
  }
}
class ListCommentsResponse {
  static fromProto(proto) {
    let m = new ListCommentsResponse();
    m = Object.assign(m, proto);
    if (proto.comments) {
      m.comments = proto.comments.map(Comment.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.comments !== 'undefined' && this.comments !== null) {
      toReturn['comments'] = 'toApiJson' in this.comments ? this.comments.toApiJson() : this.comments;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListFacebookPagesRequest {
  static fromProto(proto) {
    let m = new ListFacebookPagesRequest();
    m = Object.assign(m, proto);
    if (proto.options) {
      m.options = PagedRequestOptions.fromProto(proto.options);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    return toReturn;
  }
}
class ListFacebookPagesResponse {
  static fromProto(proto) {
    let m = new ListFacebookPagesResponse();
    m = Object.assign(m, proto);
    if (proto.pages) {
      m.pages = proto.pages.map(Page.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pages !== 'undefined' && this.pages !== null) {
      toReturn['pages'] = 'toApiJson' in this.pages ? this.pages.toApiJson() : this.pages;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListInstagramBusinessRequest {
  static fromProto(proto) {
    let m = new ListInstagramBusinessRequest();
    m = Object.assign(m, proto);
    if (proto.options) {
      m.options = PagedRequestOptions.fromProto(proto.options);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    return toReturn;
  }
}
class ListInstagramBusinessResponse {
  static fromProto(proto) {
    let m = new ListInstagramBusinessResponse();
    m = Object.assign(m, proto);
    if (proto.instagramBusiness) {
      m.instagramBusiness = proto.instagramBusiness.map(InstagramBusiness.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.instagramBusiness !== 'undefined' && this.instagramBusiness !== null) {
      toReturn['instagramBusiness'] = 'toApiJson' in this.instagramBusiness ? this.instagramBusiness.toApiJson() : this.instagramBusiness;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListMediaRequest {
  static fromProto(proto) {
    let m = new ListMediaRequest();
    m = Object.assign(m, proto);
    if (proto.options) {
      m.options = PagedRequestOptions.fromProto(proto.options);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    return toReturn;
  }
}
class ListMediaResponse {
  static fromProto(proto) {
    let m = new ListMediaResponse();
    m = Object.assign(m, proto);
    if (proto.media) {
      m.media = proto.media.map(Media.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.media !== 'undefined' && this.media !== null) {
      toReturn['media'] = 'toApiJson' in this.media ? this.media.toApiJson() : this.media;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListUsersByMultiBusinessesRequest {
  static fromProto(proto) {
    let m = new ListUsersByMultiBusinessesRequest();
    m = Object.assign(m, proto);
    if (proto.options) {
      m.options = PagedRequestOptions.fromProto(proto.options);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    return toReturn;
  }
}
class ListUsersByMultiBusinessesResponse {
  static fromProto(proto) {
    let m = new ListUsersByMultiBusinessesResponse();
    m = Object.assign(m, proto);
    if (proto.users) {
      m.users = proto.users.map(User.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.users !== 'undefined' && this.users !== null) {
      toReturn['users'] = 'toApiJson' in this.users ? this.users.toApiJson() : this.users;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListUsersRequest {
  static fromProto(proto) {
    let m = new ListUsersRequest();
    m = Object.assign(m, proto);
    if (proto.options) {
      m.options = PagedRequestOptions.fromProto(proto.options);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    return toReturn;
  }
}
class ListUsersResponse {
  static fromProto(proto) {
    let m = new ListUsersResponse();
    m = Object.assign(m, proto);
    if (proto.users) {
      m.users = proto.users.map(User.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.users !== 'undefined' && this.users !== null) {
      toReturn['users'] = 'toApiJson' in this.users ? this.users.toApiJson() : this.users;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ManageMediaTagsRequest {
  static fromProto(proto) {
    let m = new ManageMediaTagsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.mediaId !== 'undefined') {
      toReturn['mediaId'] = this.mediaId;
    }
    if (typeof this.addTags !== 'undefined') {
      toReturn['addTags'] = this.addTags;
    }
    if (typeof this.removeTags !== 'undefined') {
      toReturn['removeTags'] = this.removeTags;
    }
    return toReturn;
  }
}
class ManageMediaTagsResponse {
  static fromProto(proto) {
    let m = new ManageMediaTagsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    return toReturn;
  }
}
class MediaStats {
  static fromProto(proto) {
    let m = new MediaStats();
    m = Object.assign(m, proto);
    if (proto.commentsCount) {
      m.commentsCount = parseInt(proto.commentsCount, 10);
    }
    if (proto.likeCount) {
      m.likeCount = parseInt(proto.likeCount, 10);
    }
    if (proto.reach) {
      m.reach = parseInt(proto.reach, 10);
    }
    if (proto.saves) {
      m.saves = parseInt(proto.saves, 10);
    }
    if (proto.videoViews) {
      m.videoViews = parseInt(proto.videoViews, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.commentsCount !== 'undefined') {
      toReturn['commentsCount'] = this.commentsCount;
    }
    if (typeof this.likeCount !== 'undefined') {
      toReturn['likeCount'] = this.likeCount;
    }
    if (typeof this.reach !== 'undefined') {
      toReturn['reach'] = this.reach;
    }
    if (typeof this.saves !== 'undefined') {
      toReturn['saves'] = this.saves;
    }
    if (typeof this.videoViews !== 'undefined') {
      toReturn['videoViews'] = this.videoViews;
    }
    return toReturn;
  }
}
class GetMultiMediaStatsResponseMediaStatsEntry {
  static fromProto(proto) {
    let m = new GetMultiMediaStatsResponseMediaStatsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = MediaStats.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class PopulateRecentMediaRequest {
  static fromProto(proto) {
    let m = new PopulateRecentMediaRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class PostMediaRequest {
  static fromProto(proto) {
    let m = new PostMediaRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.mediaId !== 'undefined') {
      toReturn['mediaId'] = this.mediaId;
    }
    return toReturn;
  }
}
class PostMediaResponse {
  static fromProto(proto) {
    let m = new PostMediaResponse();
    m = Object.assign(m, proto);
    if (proto.media) {
      m.media = Media.fromProto(proto.media);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.media !== 'undefined' && this.media !== null) {
      toReturn['media'] = 'toApiJson' in this.media ? this.media.toApiJson() : this.media;
    }
    return toReturn;
  }
}
class UpdateMediaInsightsRequest {
  static fromProto(proto) {
    let m = new UpdateMediaInsightsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.mediaId !== 'undefined') {
      toReturn['mediaId'] = this.mediaId;
    }
    return toReturn;
  }
}
class UpdateMediaRequest {
  static fromProto(proto) {
    let m = new UpdateMediaRequest();
    m = Object.assign(m, proto);
    if (proto.postDateTime) {
      m.postDateTime = new Date(proto.postDateTime);
    }
    if (proto.metaData) {
      m.metaData = proto.metaData.map(MetaData.fromProto);
    }
    if (proto.mediaEntries) {
      m.mediaEntries = proto.mediaEntries.map(MediaEntry.fromProto);
    }
    if (proto.postType) {
      m.postType = enumStringToValue$2(PostType, proto.postType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.mediaId !== 'undefined') {
      toReturn['mediaId'] = this.mediaId;
    }
    if (typeof this.postText !== 'undefined') {
      toReturn['postText'] = this.postText;
    }
    if (typeof this.imageUrl !== 'undefined') {
      toReturn['imageUrl'] = this.imageUrl;
    }
    if (typeof this.postDateTime !== 'undefined' && this.postDateTime !== null) {
      toReturn['postDateTime'] = 'toApiJson' in this.postDateTime ? this.postDateTime.toApiJson() : this.postDateTime;
    }
    if (typeof this.hasScheduledTask !== 'undefined') {
      toReturn['hasScheduledTask'] = this.hasScheduledTask;
    }
    if (typeof this.videoUrl !== 'undefined') {
      toReturn['videoUrl'] = this.videoUrl;
    }
    if (typeof this.linkShortcodes !== 'undefined') {
      toReturn['linkShortcodes'] = this.linkShortcodes;
    }
    if (typeof this.metaData !== 'undefined' && this.metaData !== null) {
      toReturn['metaData'] = 'toApiJson' in this.metaData ? this.metaData.toApiJson() : this.metaData;
    }
    if (typeof this.mediaEntries !== 'undefined' && this.mediaEntries !== null) {
      toReturn['mediaEntries'] = 'toApiJson' in this.mediaEntries ? this.mediaEntries.toApiJson() : this.mediaEntries;
    }
    if (typeof this.postType !== 'undefined') {
      toReturn['postType'] = this.postType;
    }
    if (typeof this.multilocationPostId !== 'undefined') {
      toReturn['multilocationPostId'] = this.multilocationPostId;
    }
    if (typeof this.brandId !== 'undefined') {
      toReturn['brandId'] = this.brandId;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class MediaStatsHistory {
  static fromProto(proto) {
    let m = new MediaStatsHistory();
    m = Object.assign(m, proto);
    if (proto.saves) {
      m.saves = parseInt(proto.saves, 10);
    }
    if (proto.videoViews) {
      m.videoViews = parseInt(proto.videoViews, 10);
    }
    if (proto.likesCount) {
      m.likesCount = parseInt(proto.likesCount, 10);
    }
    if (proto.reach) {
      m.reach = parseInt(proto.reach, 10);
    }
    if (proto.commentsCount) {
      m.commentsCount = parseInt(proto.commentsCount, 10);
    }
    if (proto.postedDateTime) {
      m.postedDateTime = new Date(proto.postedDateTime);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.statsDateTime) {
      m.statsDateTime = new Date(proto.statsDateTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.internalPostId !== 'undefined') {
      toReturn['internalPostId'] = this.internalPostId;
    }
    if (typeof this.saves !== 'undefined') {
      toReturn['saves'] = this.saves;
    }
    if (typeof this.videoViews !== 'undefined') {
      toReturn['videoViews'] = this.videoViews;
    }
    if (typeof this.likesCount !== 'undefined') {
      toReturn['likesCount'] = this.likesCount;
    }
    if (typeof this.reach !== 'undefined') {
      toReturn['reach'] = this.reach;
    }
    if (typeof this.commentsCount !== 'undefined') {
      toReturn['commentsCount'] = this.commentsCount;
    }
    if (typeof this.postedDateTime !== 'undefined' && this.postedDateTime !== null) {
      toReturn['postedDateTime'] = 'toApiJson' in this.postedDateTime ? this.postedDateTime.toApiJson() : this.postedDateTime;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.statsDateTime !== 'undefined' && this.statsDateTime !== null) {
      toReturn['statsDateTime'] = 'toApiJson' in this.statsDateTime ? this.statsDateTime.toApiJson() : this.statsDateTime;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PublishMediaRequest {
  static fromProto(proto) {
    let m = new PublishMediaRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.mediaId !== 'undefined') {
      toReturn['mediaId'] = this.mediaId;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'instagram-api.vendasta-local.com',
  'test': '',
  'demo': 'instagram-demo.apigateway.co',
  'prod': 'instagram-prod.apigateway.co',
  'production': 'instagram-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let InstagramApiService = /*#__PURE__*/(() => {
  class InstagramApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createUser(r) {
      const request = r.toApiJson ? r : new CreateUserRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/CreateUser", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listUsers(r) {
      const request = r.toApiJson ? r : new ListUsersRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/ListUsers", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListUsersResponse.fromProto(resp)));
    }
    listUsersByMultiBusinesses(r) {
      const request = r.toApiJson ? r : new ListUsersByMultiBusinessesRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/ListUsersByMultiBusinesses", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListUsersByMultiBusinessesResponse.fromProto(resp)));
    }
    getUser(r) {
      const request = r.toApiJson ? r : new GetUserRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/GetUser", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetUserResponse.fromProto(resp)));
    }
    deleteUser(r) {
      const request = r.toApiJson ? r : new DeleteUserRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/DeleteUser", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    populateRecentMedia(r) {
      const request = r.toApiJson ? r : new PopulateRecentMediaRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/PopulateRecentMedia", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createMedia(r) {
      const request = r.toApiJson ? r : new CreateMediaRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/CreateMedia", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateMediaResponse.fromProto(resp)));
    }
    listMedia(r) {
      const request = r.toApiJson ? r : new ListMediaRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/ListMedia", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListMediaResponse.fromProto(resp)));
    }
    getMedia(r) {
      const request = r.toApiJson ? r : new GetMediaRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/GetMedia", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMediaResponse.fromProto(resp)));
    }
    deleteMedia(r) {
      const request = r.toApiJson ? r : new DeleteMediaRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/DeleteMedia", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    postMedia(r) {
      const request = r.toApiJson ? r : new PostMediaRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/PostMedia", request.toApiJson(), this.apiOptions()).pipe(map(resp => PostMediaResponse.fromProto(resp)));
    }
    updateMedia(r) {
      const request = r.toApiJson ? r : new UpdateMediaRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/UpdateMedia", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiMediaStats(r) {
      const request = r.toApiJson ? r : new GetMultiMediaStatsRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/GetMultiMediaStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiMediaStatsResponse.fromProto(resp)));
    }
    createComment(r) {
      const request = r.toApiJson ? r : new CreateCommentRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/CreateComment", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateCommentResponse.fromProto(resp)));
    }
    listComments(r) {
      const request = r.toApiJson ? r : new ListCommentsRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/ListComments", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCommentsResponse.fromProto(resp)));
    }
    listFacebookPages(r) {
      const request = r.toApiJson ? r : new ListFacebookPagesRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/ListFacebookPages", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFacebookPagesResponse.fromProto(resp)));
    }
    getInstagramBusiness(r) {
      const request = r.toApiJson ? r : new GetInstagramBusinessRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/GetInstagramBusiness", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetInstagramBusinessResponse.fromProto(resp)));
    }
    listInstagramBusiness(r) {
      const request = r.toApiJson ? r : new ListInstagramBusinessRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/ListInstagramBusiness", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListInstagramBusinessResponse.fromProto(resp)));
    }
    connectInstagramBusiness(r) {
      const request = r.toApiJson ? r : new ConnectInstagramBusinessRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/ConnectInstagramBusiness", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    manageMediaTags(r) {
      const request = r.toApiJson ? r : new ManageMediaTagsRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/ManageMediaTags", request.toApiJson(), this.apiOptions()).pipe(map(resp => ManageMediaTagsResponse.fromProto(resp)));
    }
    getBusinessStats(r) {
      const request = r.toApiJson ? r : new GetBusinessStatsRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/GetBusinessStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBusinessStatsResponse.fromProto(resp)));
    }
    getMultiMedia(r) {
      const request = r.toApiJson ? r : new GetMultiMediaRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/GetMultiMedia", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiMediaResponse.fromProto(resp)));
    }
    updateMediaInsights(r) {
      const request = r.toApiJson ? r : new UpdateMediaInsightsRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/UpdateMediaInsights", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    processBusinessStats() {
      return this.http.post(this._host + "/instagram.v1.Instagram/ProcessBusinessStats", {}, {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    breakInstagramUserToken(r) {
      const request = r.toApiJson ? r : new BreakInstagramUserTokenRequest(r);
      return this.http.post(this._host + "/instagram.v1.Instagram/BreakInstagramUserToken", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  InstagramApiService.ɵfac = function InstagramApiService_Factory(t) {
    return new (t || InstagramApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  InstagramApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: InstagramApiService,
    factory: InstagramApiService.ɵfac,
    providedIn: 'root'
  });
  return InstagramApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class InstagramPagedResponse {
  constructor(results, nextCursor, hasMore) {
    this.results = results;
    this.nextCursor = nextCursor;
    this.hasMore = hasMore;
  }
}
let InstagramService = /*#__PURE__*/(() => {
  class InstagramService {
    constructor(apiService) {
      this.apiService = apiService;
    }
    listUsers(partnerId, businessId, cursor, pageSize) {
      const req = new ListUsersRequest({
        partnerId: partnerId,
        businessId: businessId,
        options: {
          cursor: cursor,
          pageSize: pageSize ? pageSize : 0
        }
      });
      return this.apiService.listUsers(req).pipe(map(resp => ({
        results: resp.users,
        nextCursor: resp.pagingMetadata ? resp.pagingMetadata.nextCursor : '',
        hasMore: resp.pagingMetadata ? resp.pagingMetadata.hasMore : false
      })));
    }
    getUser(partnerId, businessId, userId) {
      const req = new GetUserRequest({
        partnerId: partnerId,
        businessId: businessId,
        userId: userId
      });
      return this.apiService.getUser(req).pipe(map(resp => resp.user));
    }
    deleteUser(partnerId, businessId, userId) {
      const req = new DeleteUserRequest({
        partnerId: partnerId,
        businessId: businessId,
        userId: userId
      });
      return this.apiService.deleteUser(req);
    }
    listFacebookPages(partnerId, businessId, userId, cursor, pageSize) {
      const req = new ListFacebookPagesRequest({
        partnerId: partnerId,
        businessId: businessId,
        userId: userId,
        options: {
          cursor: cursor,
          pageSize: pageSize ? pageSize : 0
        }
      });
      return this.apiService.listFacebookPages(req).pipe(map(resp => ({
        results: resp.pages,
        nextCursor: resp.pagingMetadata ? resp.pagingMetadata.nextCursor : '',
        hasMore: resp.pagingMetadata ? resp.pagingMetadata.hasMore : false
      })));
    }
    listInstagramBusiness(partnerId, businessId, userId, cursor, pageSize) {
      const req = new ListInstagramBusinessRequest({
        partnerId: partnerId,
        businessId: businessId,
        userId: userId,
        options: {
          cursor: cursor,
          pageSize: pageSize ? pageSize : 0
        }
      });
      return this.apiService.listInstagramBusiness(req).pipe(map(resp => ({
        results: resp.instagramBusiness,
        nextCursor: resp.pagingMetadata ? resp.pagingMetadata.nextCursor : '',
        hasMore: resp.pagingMetadata ? resp.pagingMetadata.hasMore : false
      })));
    }
    getInstagramBusiness(partnerId, businessId, userId, facebookPageId) {
      const req = new GetInstagramBusinessRequest({
        partnerId: partnerId,
        businessId: businessId,
        userId: userId,
        facebookPageId: facebookPageId
      });
      return this.apiService.getInstagramBusiness(req).pipe(map(resp => resp.instagramBusiness));
    }
    connectInstagramBusiness(partnerId, businessId, userId, facebookPageId, instagramBusinessId) {
      const req = new ConnectInstagramBusinessRequest({
        partnerId: partnerId,
        businessId: businessId,
        userId: userId,
        facebookPageId: facebookPageId,
        instagramBusinessId: instagramBusinessId
      });
      return this.apiService.connectInstagramBusiness(req);
    }
    listUsersByMultiBusinesses(businessIds, cursor, pageSize) {
      const req = new ListUsersByMultiBusinessesRequest({
        businessId: businessIds,
        options: {
          cursor: cursor,
          pageSize: pageSize ? pageSize : 0
        }
      });
      return this.apiService.listUsersByMultiBusinesses(req).pipe(map(resp => ({
        results: resp.users,
        nextCursor: resp.pagingMetadata ? resp.pagingMetadata.nextCursor : '',
        hasMore: resp.pagingMetadata ? resp.pagingMetadata.hasMore : false
      })));
    }
  }
  InstagramService.ɵfac = function InstagramService_Factory(t) {
    return new (t || InstagramService)(i0.ɵɵinject(InstagramApiService));
  };
  InstagramService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: InstagramService,
    factory: InstagramService.ɵfac,
    providedIn: 'root'
  });
  return InstagramService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { BreakInstagramUserTokenRequest, BusinessStats, BusinessStatsError, BusinessStatsStats, Comment, ConnectInstagramBusinessRequest, CreateCommentRequest, CreateCommentResponse, CreateMediaRequest, CreateMediaResponse, CreateUserRequest, DeleteMediaRequest, DeleteUserRequest, GetBusinessStatsRequest, GetBusinessStatsResponse, GetBusinessStatsResponseStatus, GetInstagramBusinessRequest, GetInstagramBusinessResponse, GetMediaRequest, GetMediaResponse, GetMultiMediaRequest, GetMultiMediaResponse, GetMultiMediaStatsRequest, GetMultiMediaStatsResponse, GetMultiMediaStatsResponseMediaStatsEntry, GetUserRequest, GetUserResponse, InstagramApiService, InstagramBusiness, InstagramPagedResponse, InstagramService, ListCommentsRequest, ListCommentsResponse, ListFacebookPagesRequest, ListFacebookPagesResponse, ListInstagramBusinessRequest, ListInstagramBusinessResponse, ListMediaRequest, ListMediaResponse, ListUsersByMultiBusinessesRequest, ListUsersByMultiBusinessesResponse, ListUsersRequest, ListUsersResponse, ManageMediaTagsRequest, ManageMediaTagsResponse, Media, MediaEntry, MediaKeyset, MediaStats, MediaStatsHistory, MetaData, Page, PagedRequestOptions, PagedResponseMetadata, PopulateRecentMediaRequest, PostMediaRequest, PostMediaResponse, PostType, PublishMediaRequest, UpdateMediaInsightsRequest, UpdateMediaRequest, User };
